<template>
  <div v-loading="dataLoading" class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component
        ref="search"
        class="dispute-search"
        :search-condition="searchCondition"
        :search-buttons="searchButtons"
        :searchButtonMaxNum="3"
        :fuzzySearchPlaceholder="$t('message.alert.resellerSubMerchantId')"
        :fuzzySearchKey="'resellerSubMerchantId'"
        router-name="/risk/ethoca/enrollments/list"
      >
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table
        :table-set="tableCondition"
        :service-function="queryEthocaEnrollmentList"
        ref="table"
        :is-first-automatic-visit="false"
        router-name="/risk/ethoca/enrollments/list"
      >
      </custom-table>
    </div>
    <UploadModal
      ref="uploadModal"
      :titleText="$t('message.common.import')"
      templateFileName="ethoca_enrollment_template.xlsx"
      templateFileNameShow="ONREWAY_Ethoca_Enrollment_Application_Form_Sample.xlsx"
      :uploadFunc="onUploadFile"
      accept="excel">
    </UploadModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import UploadModal from '@/components/modal/base-modal/upload-modal.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { REQUIRED } from '@/components/validation/tool/validator';
import { getCurrentMenu } from '@/layout/base/components/inavbar/utils';
import GlobalData from '@/utils/global/index';
import {
  getEnantiomericValue, initSelectedData,
} from '@/utils/tools/constant';
import { queryEthocaEnrollmentList, downloadEthocaEnrollmentList, batchImportEthocaEnrollment } from '@/views/risk/api/ethoca';

export default {
  components: {
    SearchComponent,
    CustomTable,
    UploadModal,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
      dataLoading: false,
      checkedAll: false,
      searchCondition: [
        // {
        //   key: ['createTimeStart', 'createTimeEnd'],
        //   name: 'message.alert.enrollmentTime',
        //   defValue: ['', ''],
        //   type: 'date_time',
        // },
        {
          key: 'enrollmentStatusList',
          name: 'message.alert.enrollmentStatus',
          type: 'select',
          defValue: [''],
          multiple: true,
          isInternationalization: true,
          options: [],
          changeValue: (value) => {
            let list = [];
            if ((value[value.length - 1] === '')) {
              list = [''];
            } else {
              list = value.filter(item => item !== '');
            }
            this.$refs.search.setInputValue('enrollmentStatusList', list);
          },
        },
        {
          key: 'billDesc',
          name: 'message.alert.billDesc',
          type: 'input',
          defValue: '',
          placeholder: 'message.alert.billingDescriptorInputTips',
        },
        {
          key: ['updateTimeStart', 'updateTimeEnd'],
          name: 'message.alert.updateDate',
          defValue: ['', ''],
          type: 'date_time',
        },
      ],
      searchButtons: [
        {
          type: 'download',
          permissionCode: 'risk:ethoca:enrollments:list:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                const res = await downloadEthocaEnrollmentList(param);
                if (res) {
                  window.location.href = res;
                  ShowSuccessMessage(this.$t('message.downloadSuccessfulTip'));
                }
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
        {
          type: 'other',
          name: 'message.common.import',
          buttonType: 'default',
          permissionCode: 'risk:ethoca:enrollments:list:import',
          func: () => {
            this.$refs.uploadModal.openModal();
          },
        },
        {
          type: 'other',
          name: 'message.common.new',
          buttonType: 'default',
          permissionCode: 'risk:ethoca:enrollments:list:add',
          func: () => {
            this.$router.push({
              path: '/risk/ethoca/enrollments/edit',
            });
          },
        },
      ],
      tableCondition: [
        {
          titleBar: {
            type: 'text',
            title: 'message.alert.preDisputeService',
          },
          key: 'preDisputeService',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.preDisputeServiceList, data.preDisputeService),
        },
        {
          titleBar: {
            type: 'text',
            title: 'message.alert.billDesc',
          },
          key: 'billDesc',
          type: 'text',
        },
        {
          titleBar: {
            type: 'text',
            title: 'message.alert.resellerSubMerchantId',
          },
          key: 'resellerSubMerchantId',
          type: 'text',
        },
        {
          titleBar: {
            type: 'text',
            title: 'message.alert.enrollmentStatus',
          },
          key: 'enrollmentStatus',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.enrollmentStatusList, data.enrollmentStatus),
        },
        {
          titleBar: {
            type: 'text',
            title: 'message.alert.comments',
          },
          key: 'comments',
          type: 'text',
        },
        {
          titleBar: {
            type: 'text',
            title: 'message.alert.updatedUser',
          },
          key: 'updateOpr',
          type: 'text',
        },
        {
          titleBar: {
            type: 'text',
            title: 'message.alert.lastUpdatedDate',
          },
          key: 'updateTime',
          type: 'text',
        },
        {
          key: 'buttons',
          titleBar: {
            title: 'message.tableCommon.operation',
            type: 'operations',
          },
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.details',
              permissionCode: 'risk:ethoca:enrollments:list:see',
              func: (data) => {
                this.$router.push({
                  path: '/risk/ethoca/enrollments/view',
                  query: {
                    id: data.id,
                  },
                });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.common.edit',
              permissionCode: 'risk:ethoca:enrollments:list:edit',
              isDisplayFunc: (data) => (!['ENROLLING', 'DISENROLLING'].includes(data.enrollmentStatus)),
              func: (data) => {
                this.$router.push({
                  path: '/risk/ethoca/enrollments/edit',
                  query: {
                    id: data.id,
                  },
                });
              },
            },
          ],
        },
      ],
      enrollmentStatusList: [],
      preDisputeServiceList: [],
    };
  },
  beforeCreate() {
    try {
      const menu = getCurrentMenu(this.$store.getters.permission.menus, {
        path: '/risk/ethoca',
        meta: {
          resourceCode: 'risk:ethoca',
        },
      });
      const index = menu.childrenNode[0].menuUrl;
      if (index !== '/risk/ethoca/enrollments/list') {
        this.$router.push({ path: index });
      }
    } catch (err) {
      //
    }
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    queryEthocaEnrollmentList,
    async initMethod() {
      this.dataLoading = true;
      try {
        const dict = await GlobalData.getDictList(['ACW_ENROLLMENT_STATUS', 'ETHOCA_ACW_PRE_DISPUTE_SERVICE']);
        this.enrollmentStatusList = initSelectedData(dict.ACW_ENROLLMENT_STATUS);
        this.preDisputeServiceList = initSelectedData(dict.ETHOCA_ACW_PRE_DISPUTE_SERVICE);
        this.$refs.search.setSearchSelectOptions('enrollmentStatusList', this.enrollmentStatusList);
        if (this.$refs.table) {
          this.$refs.table.firstVisitHttp();
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    refreshTable() {
      this.$refs.table.refreshTable();
    },
    async onUploadFile(params) {
      const res = await batchImportEthocaEnrollment(params);
      return res;
    },
  },
};
</script>
<style lang="scss">
</style>
